// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f17a6456","57":"ad1be719","323":"504ed70c","411":"f11d27d3","482":"19285bd9","639":"e80f94a3","652":"9bf82b3a","894":"14cc9ec3"}[chunkId] + ".chunk.js";
};